import type { ContactInfo } from '@/features/tax-profile/ContactInfo'
import { action, observable } from 'mobx'
import { pattern, required, validationContext } from 'validx'
import { validateObject, isValidUsPhoneNumber } from '@/utils/validx-util'
import { PhysicalAddressEditorViewModel } from '@/features/tax-profile/PhysicalAddressEditorViewModel'

/**
 * View model for editing contact information.
 */
export class ContactInfoEditorViewModel {
  @observable accessor email = ''
  @observable accessor phoneNumber = ''

  readonly physicalAddressVm = new PhysicalAddressEditorViewModel()

  readonly validation = validationContext(this, {
    email: [
      required('Email is required'),
      pattern('email', 'Must be a valid email'),
    ],
    phoneNumber: [required('Phone number is required'), isValidUsPhoneNumber()],
    physicalAddressVm: [validateObject()],
  })

  /**
   * Resets the state of the view model to that of the given
   * info, or defaults if none is specified.
   *
   * @param info
   */
  @action.bound
  reset(info?: ContactInfo) {
    this.email = info?.email ?? ''
    this.phoneNumber = info?.phoneNumber ?? ''
    this.physicalAddressVm.reset(info?.physicalAddress)

    this.validation.reset()
  }

  /**
   * Maps the state of the VM to {@link ContactInfo}.
   */
  toContactInfo(): ContactInfo {
    return {
      email: this.email,
      phoneNumber: this.phoneNumber,
      physicalAddress: this.physicalAddressVm.toPhysicalAddress(),
    }
  }
}
